"use strict";

var _createForOfIteratorHelper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var conversions = require("webidl-conversions");

var utils = require("./utils.js");

var EventInit = require("./EventInit.js");

module.exports = {
  convertInherit: function convertInherit(obj, ret) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$context = _ref.context,
        context = _ref$context === void 0 ? "The provided value" : _ref$context;

    EventInit.convertInherit(obj, ret, {
      context: context
    });
    {
      var key = "data";
      var value = obj === undefined || obj === null ? undefined : obj[key];

      if (value !== undefined) {
        value = conversions["any"](value, {
          context: context + " has member data that"
        });
        ret[key] = value;
      } else {
        ret[key] = null;
      }
    }
    {
      var _key = "lastEventId";

      var _value = obj === undefined || obj === null ? undefined : obj[_key];

      if (_value !== undefined) {
        _value = conversions["DOMString"](_value, {
          context: context + " has member lastEventId that"
        });
        ret[_key] = _value;
      } else {
        ret[_key] = "";
      }
    }
    {
      var _key2 = "origin";

      var _value2 = obj === undefined || obj === null ? undefined : obj[_key2];

      if (_value2 !== undefined) {
        _value2 = conversions["USVString"](_value2, {
          context: context + " has member origin that"
        });
        ret[_key2] = _value2;
      } else {
        ret[_key2] = "";
      }
    }
    {
      var _key3 = "ports";

      var _value3 = obj === undefined || obj === null ? undefined : obj[_key3];

      if (_value3 !== undefined) {
        if (!utils.isObject(_value3)) {
          throw new TypeError(context + " has member ports that" + " is not an iterable object.");
        } else {
          var V = [];
          var tmp = _value3;

          var _iterator = _createForOfIteratorHelper(tmp),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var nextItem = _step.value;
              nextItem = utils.tryImplForWrapper(nextItem);
              V.push(nextItem);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          _value3 = V;
        }

        ret[_key3] = _value3;
      } else {
        ret[_key3] = [];
      }
    }
    {
      var _key4 = "source";

      var _value4 = obj === undefined || obj === null ? undefined : obj[_key4];

      if (_value4 !== undefined) {
        if (_value4 === null || _value4 === undefined) {
          _value4 = null;
        } else {
          _value4 = utils.tryImplForWrapper(_value4);
        }

        ret[_key4] = _value4;
      } else {
        ret[_key4] = null;
      }
    }
  },
  convert: function convert(obj) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$context = _ref2.context,
        context = _ref2$context === void 0 ? "The provided value" : _ref2$context;

    if (obj !== undefined && typeof obj !== "object" && typeof obj !== "function") {
      throw new TypeError("".concat(context, " is not an object."));
    }

    var ret = Object.create(null);
    module.exports.convertInherit(obj, ret, {
      context: context
    });
    return ret;
  }
};